export const ReclamationStatut = {
    Ouvert: 0,
    EnCours: 1,
    Reaffecte: 2,
    ClotureClient: 3,
    ClotureDefinitive: 4
};

export const ReclamationStatuts = [
    'Ouvert',
    'En cours',
    'Réaffecté',
    'Clôture client',
    'Clôture définitive'
];

export const AnomalieType = {
    QuantiteArticleIncorrecte: 0,
    ErreurProduit: 1,
    DefautProduitManqueAccessoire: 2,
    DefautProduitAspectDeballage: 3,
    ColisAbime: 4,
    DefautProduitPremiereUtilisation: 5,
    DemandeRetour: 6,
    PasCommande: 7,
    ClientPasRetirerMarchandise: 8,
    DemandeRetourVolontaire: 9
};

export const ReclamationFiltre = {
    Toutes: 0,
    MaSelection: 1,
    Commentaires: 2,
    Cloturees: 3,
    AVerifier: 4,
    RetourPlateforme: 5,
    ARelancer: 6,
};
export const ReclamationFiltreNoms = [
    'Toutes',
    'MaSelection',
    'Commentaires',
    'Cloturees',
    'AVerifier',
    'RetourPlateforme',
    'ARelancer',
];

export const Domaine = {
    Foussier: 0,
    Lba: 1
};

export const TypeActionCodes = {
    Creation: 'CREATION',
    Question: 'QUESTION',
    Reponse: 'REPONSE',
    Memo: 'MEMO',
    Cloture: 'CLOTURE',
    AnnulerCloture: 'ANNULER_CLOTURE',
    AffectationGroupe: 'AFFECTATION_GROUPE',
    AffectationUtilisateur: 'AFFECTATION_UTILISATEUR',
    ObservateurAjout: 'OBSERVATEUR_AJOUT',
    ObservateurSuppression: 'OBSERVATEUR_SUPPRESSION',
    ModificationDateVerification: 'MODIFICATION_DATE_VERIFICATION',
    ReclamationLiee: 'RECLAMATION_LIEE',
    //NotifierDepartMagasin: 'NOTIFIER_DEPART_MAGASIN', // Obsolete, ne peux plus être généré, RECLA-678

    TransportRechercheColisSiteWeb: 'TRANSPORT_RECHERCHE_COLIS_SITE_WEB',
    TransportDemanderRelivraison: 'TRANSPORT_DEMANDER_RELIVRAISON',
    TransportDemanderImperatif: 'TRANSPORT_DEMANDER_IMPERATIF',
    TransportDemanderRechercheColis: 'TRANSPORT_DEMANDER_RECHERCHE_COLIS',
    TransportRenvoiAvecFacturation: 'TRANSPORT_RENVOI_AVEC_FACTURATION',
    TransportDemanderEnqueteChauffeur: 'TRANSPORT_DEMANDER_ENQUETE_CHAUFFEUR',
    TransportPlainteLivraisonSauvage: 'TRANSPORT_PLAINTE_LIVRAISON_SAUVAGE',
    TransportRenvoyerMarchandise: 'TRANSPORT_RENVOYER_MARCHANDISE',
    TransportFacturerTransporteur: 'TRANSPORT_FACTURE_TRANSPORTEUR',
    TransportDemandeEnlevement: 'TRANSPORT_DEMANDE_ENLEVEMENT',
    TransportDemandeMiseEnDestruction: 'TRANSPORT_DEMANDE_MISE_EN_DESTRUCTION',
    TransportOrdreEnlevementMatieresDangeureusesInflammables: 'TRANSPORT_ORDRE_ENLEVEMENT_MATIERES_DANGEUREUSES_INFLAMMABLES',
    TransportReponseSouffranceTransporteur: 'TRANSPORT_REPONSE_SOUFFRANCE_TRANSPORTEUR',
    TransportDemandeEnlevementValidee: 'TRANSPORT_DEMANDE_ENLEVEMENT_VALIDEE',

    QualiteEntrepotDemandeInformations: 'QUALITE_ENTREPOT_DEMANDE_INFORMATIONS',
    QualiteEntrepotControlePoids: 'QUALITE_ENTREPOT_CONTROLE_POIDS',
    QualiteEntrepotControleStock: 'QUALITE_ENTREPOT_CONTROLE_STOCK',
    QualiteEntrepotRenvoiEnGratuit: 'QUALITE_ENTREPOT_RENVOI_EN_GRATUIT',
    QualiteEntrepotRenvoiEnPayant: 'QUALITE_ENTREPOT_RENVOI_EN_PAYANT',
    QualiteEntrepotAvoirClient: 'QUALITE_ENTREPOT_AVOIR_CLIENT',
    QualiteEntrepotBLCorrectif: 'QUALITE_ENTREPOT_BL_CORRECTIF',
    QualiteEntrepotRetourGeneralMagasins: 'QUALITE_ENTREPOT_RETOUR_GENERAL_MAGASINS',
    QualiteEntrepotDemanderRegularisationStockMagasin: 'QUALITE_ENTREPOT_DEMANDER_REGULARISATION_STOCK_MAGASIN',
    QualiteEntrepotDemanderControleStockMagasin: 'QUALITE_ENTREPOT_DEMANDER_CONTROLE_STOCK_MAGASIN',
    QualiteEntrepotDemanderRetourDepuisUnMagasin: 'QUALITE_ENTREPOT_DEMANDER_RETOUR_DEPUIS_UN_MAGASIN',

    MagasinProblemeQualiteProduit: 'MAGASIN_PROBLEME_QUALITE_PRODUIT',
    MagasinProblemeTransport: 'MAGASIN_PROBLEME_TRANSPORT',
    MagasinErreurQuantite: 'MAGASIN_ERREUR_QUANTITE',
    MagasinDeclarerInversionArticle: 'MAGASIN_DECLARER_INVERSION_ARTICLE',

    MagasinDeclarerRetourPlateforme: 'MAGASIN_DECLARER_RETOUR_PLATEFORME',

    SouffranceTransporteurMemo: 'SOUFFRANCE_TRANSPORTEUR_MEMO',
    SouffranceTransporteurMemoReponse: 'SOUFFRANCE_TRANSPORTEUR_MEMO_REPONSE',

    RapidoRenvoiEnPayant: 'RAPIDO_RENVOI_EN_PAYANT',

    PrevenirClientRepriseMarchandise: 'PREVENIR_CLIENT_REPRISE_MARCHANDISE',

    ForceVenteRetourFournisseur: 'FORCE_VENTE_RETOUR_FOURNISSEUR',

    SavPretArticle: 'SAV_PRET_ARTICLE',
    SavEnvoiProduitFournisseur: 'SAV_ENVOI_PRODUIT_FOURNISSEUR',
    SavDemandeExpertise: 'SAV_DEMANDE_EXPERTISE',
    SavGesteCommercial: 'SAV_GESTE_COMMERCIAL',
    SavGesteCommercialReponseDR: 'SAV_GESTE_COMMERCIAL_REPONSE_DR',

    SavDemandeExpertiseFournisseur: 'SAV_DEMANDE_EXPERTISE_FOURNISSEUR',
    SavRemplacementANeuf: 'SAV_REMPLACEMENT_A_NEUF',
    SavDemandePieceDetacheeFournisseur: 'SAV_DEMANDE_PIECE_DETACHEE_FOURNISSEUR',
    SavDeclarerLitige: 'SAV_DECLARER_LITIGE',
    SavDeclarerMiseAuRebutProduit: 'SAV_DECLARER_MISE_AU_REBUT_PRODUIT',
    SavAnnulation: 'SAV_ANNULATION',
    SavReparationAdaptationSurPlace: 'SAV_REPARATION_ADAPTATION_SUR_PLACE',
    SavDetailReparation: 'SAV_DETAIL_REPARATION',
    SavSaisiePieceGestionCommerciale: 'SAV_SAISIE_PIECE_GESTION_COMMERCIALE',

    ErreurGenerationAvoir: 'ERREUR_GENERATION_AVOIR',
    SuccesGenerationAvoir: 'SUCCES_GENERATION_AVOIR',
    AbandonGenerationAvoir: 'ABANDON_GENERATION_AVOIR',

    GenerationRecent: 'GENERATION_RECENT',
    SuccesGenerationRecent: 'SUCCES_GENERATION_RECENT',
    ErreurGenerationRecent: 'ERREUR_GENERATION_RECENT',
    AbandonGenerationRecent: 'ABANDON_GENERATION_RECENT',

    // Pseudo-code (non persisté) : entrée synthétique d'historique du suivi RECENT
    ReclamationSurBonDeVente: 'RECLAMATION_SUR_BON_DE_VENTE',

    ComptabiliteDemandeVirement: 'DEMANDE_VIREMENT',
    ComptabiliteAcquittementDemandeVirement: 'ACQUITTEMENT_DEMANDE_VIREMENT',

    RelaiLitigeDemandeDeCloture: 'RELAI_LITIGE_DEMANDE_CLOTURE',
    
    /**
     * Changement de qualification - ie suite à requalification d'un litige.
     */
    Requalification: 'REQUALIFICATION',
    /**
     * Modification de la liste de pièce - ie suite à modification d'un litige.
     */
    ModificationPieces: 'MODIFICATION_PIECES',

    // Actions manuelles de correction d'écart article et de dossier lié
    DemandeCorrectionArticleSurPiece: 'DEMANDE_CORRECTION_ARTICLE_SUR_PIECE',
    DemandeDossierLieManuel: 'DEMANDE_DOSSIER_LIE_MANUEL',
};

export const ReclamationActionDetailCodes = {
    AchatInitialFoussier: 'ACHAT_INITIAL_FOUSSIER',
    ActionEffectuee: 'ACTION_EFFECTUEE',
    Adresse: 'ADRESSE',
    AdresseDestination: 'ADRESSE_DESTINATION',
    AffectationDeclenchee: 'AFFECTATION_DECLENCHEE',
    AffectationForcee: 'AFFECTATION_FORCEE',
    Avoir: 'AVOIR',
    CausePrincipale: 'CAUSE_PRINCIPALE',
    CodeArticle: 'CODE_ARTICLE',
    CodeArticleQuantite: 'CODE_ARTICLE_QUANTITE',
    // DEV-4572 : article + quantité reçus physiquement (distinct de l'article de la pièce)
    CodeArticleQuantiteRecu: 'CODE_ARTICLE_QUANTITE_RECU',
    Commentaire: 'COMMENTAIRE',
    ContactClient: 'CONTACT_CLIENT',
    ContactFournisseur: 'CONTACT_FOURNISSEUR',
    DateEnlevement: 'DATE_ENLEVEMENT',
    DateEnvoiEDITransport: 'DATE_ENVOI_EDI_TRANSPORT',
    DateExpeditionPhysique: 'DATE_EXPEDITION_PHYSIQUE',
    DateRelivraison: 'DATE_RELIVRAISON',
    DateRenvoi: 'DATE_RENVOI',
    DateVerification: 'DATE_VERIFICATION',
    DecisionFournisseur: 'DECISION_FOURNISSEUR',
    Demande: 'DEMANDE',
    Depot: 'DEPOT',
    Descriptif: 'DESCRIPTIF',
    DetailCausePrincipale: 'DETAIL_CAUSE_PRINCIPALE',
    Email: 'EMAIL',

    Fournisseur: 'FOURNISSEUR',

    GroupeAffecte: 'GROUPE_AFFECTE',
    LocalisationMarchandises: 'LOCALISATION_MARCHANDISES',
    Memo: 'MEMO',
    MontantAvoirHT: 'MONTANT_AVOIR_HT',
    MontantAvoirTTC: 'MONTANT_AVOIR_TTC',
    MontantDevis: 'MONTANT_DEVIS',
    MotifResolution: 'MOTIF_RESOLUTION',
    NombreColis: 'NOMBRE_COLIS',
    NombreLongueurs: 'NOMBRE_LONGUEURS',
    NombrePalettes: 'NOMBRE_PALETTES',
    NotificationEnlevementClient: 'NOTIFICATION_ENLEVEMENT_CLIENT',
    Notifier: 'NOTIFIER',
    NumeroCommandeAchat: 'NUMERO_COMMANDE_ACHAT',
    NumeroCommandeClient: 'NUMERO_COMMANDE_CLIENT',
    NumeroBT: 'NUMERO_BT',
    NumeroFacture: 'NUMERO_FACTURE',
    NumeroPiece: 'NUMERO_PIECE',
    NumeroPieceAvoir: 'NUMERO_PIECE_AVOIR',
    NumerosRecepisses: 'NUMEROS_RECEPISSES',
    ObservateurAjoute: 'OBSERVATEUR_AJOUTE',
    ObservateurSupprime: 'OBSERVATEUR_SUPPRIME',
    PackingList: 'PACKING_LIST',
    Plateforme: 'PLATEFORME',
    Poids: 'POIDS',
    QualificationRetour: 'QUALIFICATION_RETOUR',
    Quantite: 'QUANTITE',
    Question: 'QUESTION',
    ReclamationLiee: 'RECLAMATION_LIEE',
    Reference: 'REFERENCE',
    Reponse: 'REPONSE',
    Resultat: 'RESULTAT',
    RetourMarchandiseAttendue: 'RETOUR_MARCHANDISE_ATTENDUE',
    TicketChronopost: 'TICKET_CHRONOPOST',
    TraitementInformatique: 'TRAITEMENT_INFORMATIQUE',
    Transporteur: 'TRANSPORTEUR',
    TransporteurInitial: 'TRANSPORTEUR_INITIAL',
    TypeDemandeRetour: 'TYPE_DEMANDE_RETOUR',
    UtilisateurAffecte: 'UTILISATEUR_AFFECTE',
    UtilisateurFautif: 'UTILISATEUR_FAUTIF',
    VerificationJours: 'VERIFICATION_JOURS',

    // Réclamation sur bon de vente (RECENT)
    ReclamationSurBonDeVenteScenario: 'RECLAMATION_SUR_BON_DE_VENTE_SCENARIO',
    ReclamationSurBonDeVenteCle: 'RECLAMATION_SUR_BON_DE_VENTE_CLE'
};

export const ReclamationActionDetailType = {
    GroupeId: 0,
    UtilisateurId: 1,
    Booleen: 2,
    Texte: 3,
    ChoixSimple: 4,
    ChoixMultiple: 5,
    Entier: 6,
    Date: 7,
    Flottant: 8,
    TransporteurId: 9,
    MotifResolutionId: 10,
    CodeArticleQuantite: 11,
    CausePrincipaleId: 12,
    CausePrincipaleDetailId: 13,
    ReclamationId: 14,
    DateTime: 15,
    CodeDepot: 16,
    PackingList: 17,
    FournisseurId: 18,
    LienGeswebCommande: 19,
    ReclamationSurBonDeVente: 20,
    LienGeswebBonLivraison: 21
};


export const TypeCodes = {
    Client: 'CLIENT',
    Cession: 'CESSION',
    Interne: 'INTERNE',
};

export const CategorieCodes = {
    ProblemeReception: 'PROBLEME_RECEPTION',
    CommandePasArrivee: 'COMMANDE_PAS_ARRIVEE',
    DefautProduit: 'DEFAUT_PRODUIT',
    Interne: 'INTERNE',
    SouffranceTransporteur: 'SOUFFRANCE_TRANSPORTEUR',
    DemandeRetourMarchandiseLivreeConforme: 'DEMANDE_RETOUR_MARCHANDISE_LIVREE_CONFORME',
    ErreurAdresseLivraison: 'ERREUR_ADRESSE_LIVRAISON',
    Litige: 'LITIGE',
};

export const QualificationCodes = {
    AucunColis: 'AUCUN_COLIS',
    ManqueColis: 'MANQUE_COLIS',
    ColisAbime: 'COLIS_ABIME',
    ColisPasPourMoi: 'COLIS_PAS_POUR_MOI',
    QuantiteIncorrecte: 'QUANTITE_INCORRECTE',
    PasBonProduit: 'PAS_BON_PRODUIT',
    DefautProduitManqueAccessoire: 'DEFAUT_PRODUIT_MANQUE_ACCESSOIRE',
    DefautProduitPremiereUtilisation: 'DEFAUT_PRODUIT_PREMIERE_UTILISATION',
    DefautProduitAspectDeballage: 'DEFAUT_PRODUIT_ASPECT_DEBALLAGE',
    LivraisonSansPresence: 'LIVRAISON_SANS_PRESENCE',
    Interne: 'INTERNE',
    RetourAttenduSuiteReclamation: 'RETOUR_ATTENDU_SUITE_RECLAMATION',
    ProblemeQualiteProduit: 'PROBLEME_QUALITE_PRODUIT',
    ProblemeTransport: 'PROBLEME_TRANSPORT',

    ColisRefuse: "COLIS_REFUSE",
    AdresseErroneeInconnue: "ADRESSE_ERRONEE_INCONNUE",
    ContactTelephoneManquant: "CONTACT_TELEPHONE_MANQUANT",
    AbsentAviseNeRepondPas: "ABSENT_AVISE_NE_REPOND_PAS",
    ColisImpresentable: "COLIS_IMPRESENTABLE",
    RefusDeLivraisonPartiel: "REFUS_DE_LIVRAISON_PARTIEL",
    RetardAcheminement: "RETARD_ACHEMINEMENT",
    RetardExpedition: "RETARD_EXPEDITION",
    NonConnu: "NON_CONNU",
    ColisMatieresDangeureusesOuInflammables: "COLIS_MATIERES_DANGEUREUSES_OU_INFLAMMABLES",
    ColisDeterioreAReconditionner: "COLIS_DETERIORE_A_RECONDITIONNER",
    ColisEnDestruction: "COLIS_EN_DESTRUCTION",
    Sav: "SAV",
    ErreurDeQuantite: "ERREUR_DE_QUANTITE",
    ColisRetourneChezLExpediteur: "COLIS_RETOURNE_CHEZ_L_EXPEDITEUR",
    TropCommande: "TROP_COMMANDE",
    PlusUsage: "PLUS_USAGE",
    NeConvientpas: "NE_CONVIENT_PAS",
    PasCommande: "PAS_COMMANDE",

    InversionArticle: "INVERSION_ARTICLE",
    RetourPhysiqueSansDossier: "RETOUR_PHYSIQUE_SANS_DOSSIER",
    ClientPasRetirerMarchandise: "CLIENT_PAS_RETIRER_MARCHANDISE",

    DemandeChangementAdresse: "DEMANDE_CHANGEMENT_ADRESSE",
    ChangementAdresse: "CHANGEMENT_ADRESSE",
    ModificationAdresseLivraison: "MODIFICATION_ADRESSE_LIVRAISON",
    

    DossierEnAttente: "DOSSIER_EN_ATTENTE",

    AppelTransport: "APPEL_TRANSPORT",

    // Note les Qualifications concernant les ligites client seront ajoutées automatiquement en base mais pas ici

};

export const ReclamationQualificationDetailCodes = {
    AcceptationSAV: 'ACCEPTATION_SAV',
    AchatInitialFoussier: 'ACHAT_INITIAL_FOUSSIER',
    ActionAMener: 'ACTION_A_MENER',
    AdresseDestination: 'ADRESSE_DESTINATION',
    AdresseDestinationNouvelle: 'ADRESSE_DESTINATION_NOUVELLE',
    AdresseEnlevement: 'ADRESSE_ENLEVEMENT',
    AdresseRenvoi: 'ADRESSE_RENVOI',
    AdresseRetour: 'ADRESSE_RETOUR',
    AttacherBonRetour: 'ATTACHER_BON_RETOUR',
    AvecLivraison: 'AVEC_LIVRAISON',
    Client: 'CLIENT',
    ClientInforme: 'CLIENT_INFORME',
    CodeArticle: 'CODE_ARTICLE',
    CodeArticleQuantite: 'CODE_ARTICLE_QUANTITE',
    ColisAbimeType: 'COLIS_ABIME_TYPE',
    ColisRefuse: 'COLIS_REFUSE',
    CommentaireClient: 'COMMENTAIRE_CLIENT',
    ConfirmationDepot: 'CONFIRMATION_DEPOT',
    ConfirmationEmetteur: 'CONFIRMATION_EMETTEUR',
    ContactClient: 'CONTACT_CLIENT',
    ContactClientNom: 'CONTACT_CLIENT_NOM',
    ContactClientEmail: 'CONTACT_CLIENT_EMAIL',
    ContactClientTelephone: 'CONTACT_CLIENT_TELEPHONE',
    DelaiGarantie: 'DELAI_GARANTIE',
    DateEnlevement: 'DATE_ENLEVEMENT',
    DateLivraison: 'DATE_LIVRAISON',
    DateLivraisonDemandee: 'DATE_LIVRAISON_DEMANDEE',
    DateLivraisonEffective: 'DATE_LIVRAISON_EFFECTIVE',
    DemarcheSAV: 'DEMARCHE_SAV',
    DepannageClient: 'DEPANNAGE_CLIENT',
    DepannageDirectClient: 'DEPANNAGE_DIRECT_CLIENT',
    Depot: 'DEPOT',
    Descriptif: 'DESCRIPTIF',

    DetailSavTypeProduit: 'DETAIL_SAV_TYPE_PRODUIT',
    DetailSavCodeArticle: 'DETAIL_SAV_CODE_ARTICLE',
    DetailSavMarque: 'DETAIL_SAV_MARQUE',
    DetailSavReferenceNumerique: 'DETAIL_SAV_REFERENCE_NUMERIQUE',
    DetailSavNumeroSerie: 'DETAIL_SAV_NUMERO_SERIE',
    DetailSavDateAchat: 'DETAIL_SAV_DATE_ACHAT',
    DetailSavBLOuFacture: 'DETAIL_SAV_BL_OU_FACTURE',
    DetailSavAnneeProductionMachine: 'DETAIL_SAV_ANNEE_PRODUCTION_MACHINE',

    DetailSavConcerneAccessoire: 'DETAIL_SAV_CONCERNE_ACCESSOIRE',
    DetailSavConcerneAccessoireBatterie: 'DETAIL_SAV_CONCERNE_ACCESSOIRE_BATTERIE',
    DetailSavConcerneAccessoireChargeur: 'DETAIL_SAV_CONCERNE_ACCESSOIRE_CHARGEUR',
    DetailSavConcerneAccessoireAutre: 'DETAIL_SAV_CONCERNE_ACCESSOIRE_AUTRE',
    DetailSavConcerneAccessoireCommentaire: 'DETAIL_SAV_CONCERNE_ACCESSOIRE_COMMENTAIRE',

    DetailSavMotif: 'DETAIL_SAV_MOTIF',
    DetailSavRestitutionNbBatterie: 'DETAIL_SAV_RESTITUTION_NB_BATTERIE',
    DetailSavRestitutionNbChargeur: 'DETAIL_SAV_RESTITUTION_NB_CHARGEUR',
    DetailSavRestitutionNbSystainer: 'DETAIL_SAV_RESTITUTION_NB_SYSTAINER',
    DetailSavRestitutionNbMandrin: 'DETAIL_SAV_RESTITUTION_NB_MANDRIN',
    DetailSavRestitutionAucune: 'DETAIL_SAV_RESTITUTION_AUCUNE',
    DetailSavRestitutionAutres: 'DETAIL_SAV_RESTITUTION_AUTRES',
    DetailSavCommentaires: 'DETAIL_SAV_COMMENTAIRES',
    DetailSavArticlePreter: 'DETAIL_SAV_ARTICLE_PRETER',
    DetailSavArticlePreterPiece: 'DETAIL_SAV_ARTICLE_PRETER_PIECE',
    DetailSavCommentaireTraitement: 'DETAIL_SAV_COMMENTAIRE_TRAITEMENT',
    DetailSavNumeroCompteFoussier: 'DETAIL_SAV_NUMERO_COMPTE_FOUSSIER',
    DetailSavNePasSelectionnerDePiece: 'DETAIL_SAV_NE_PAS_SELECTIONNER_DE_PIECE',
    DetailSavOffrirMajorationHorsGarantie: 'DETAIL_SAV_OFFRIR_MAJORATION_HORS_GARANTIE',


    Emails: 'EMAILS',
    Enlevement: 'ENLEVEMENT',
    EtatProduit: 'ETAT_PRODUIT',
    EtatLivraison: 'ETAT_LIVRAISON',
    ExtensionGarantie: 'EXTENSION_GARANTIE',
    Fournisseur: 'FOURNISSEUR',
    GarantieProduit: 'GARANTIE_PRODUIT',
    ListeCodeArticleManquant: 'LISTE_CODE_ARTICLE_MANQUANT',

    // Livraison sans presence
    LivraisonSansPresenceCommandeRecue: 'LIVRAISON_SANS_PRESENCE_COMMANDE_RECUE',
    LivraisonSansPresenceCommandeComplete: 'LIVRAISON_SANS_PRESENCE_COMMANDE_COMPLETE',
    LivraisonSansPresenceCommandeEndommagee: 'LIVRAISON_SANS_PRESENCE_COMMANDE_ENDOMMAGEE',
    LivraisonSansPresenceSignalerTransporteur: 'LIVRAISON_SANS_PRESENCE_SIGNALER_TRANSPORTEUR',

    LocalisationProduit: 'LOCALISATION_PRODUIT',
    LocalisationProduitAutreCommentaire: 'LOCALISATION_PRODUIT_AUTRE_COMMENTAIRE',
    MagasinRenvoi: 'MAGASIN_RENVOI',
    MagasinRetourATC: 'MAGASIN_RETOUR_ATC',
    ManqueMarchandise: 'MANQUE_MARCHANDISE',
    ModePriseEnCharge: 'MODE_PRISE_EN_CHARGE',
    ModePriseEnChargeATC: 'MODE_PRISE_EN_CHARGE_ATC',
    ModeRetour: 'MODE_RETOUR',
    NbColis: 'NB_COLIS',
    NbColisRecus: 'NB_COLIS_RECUS',
    NbLignes: 'NB_LIGNES',
    NbUtilisationProduit: 'NB_UTILISATION_PRODUIT',
    NomBonLivraison: 'NOM_BON_LIVRAISON',
    NomBLEqualNomClient: 'NOM_BL_EQUAL_NOM_CLIENT',
    NomEtiquette: 'NOM_ETIQUETTE',
    NombreColis: 'NOMBRE_COLIS',
    NombreLongueurs: 'NOMBRE_LONGUEURS',
    NombrePalettes: 'NOMBRE_PALETTES',
    NumeroColis: 'NUMERO_COLIS',
    NumeroColisVisible: 'NUMERO_COLIS_VISIBLE',
    NumeroPiece: 'NUMERO_PIECE',
    NumeroPieceColis: 'NUMERO_PIECE_COLIS',
    NumeroPieceSurColis: 'NUMERO_PIECE_SUR_COLIS',
    NumeroPieceEtiquette: 'NUMERO_PIECE_ETIQUETTE',
    CodeClientEtiquette: 'CODE_CLIENT_ETIQUETTE',
    AdresseLivraisonEtiquette: 'ADRESSE_LIVRAISON_ETIQUETTE',
    NumeroPreparation: 'NUMERO_PREPARATION',
    PhotoConsultee: 'PHOTO_CONSULTEE',
    PhotoJoignable: 'PHOTO_JOIGNABLE',
    Piece: 'PIECE',
    PlateformeRetour: 'PLATEFORME_RETOUR',
    Poids: 'POIDS',
    Poursuivre: 'POURSUIVRE',
    PriseConnaissanceDemarche: 'PRISE_CONNAISSANCE_DEMARCHE',
    ProduitCommande: 'PRODUIT_COMMANDE',
    PropositionAchat: 'PROPOSITION_ACHAT',
    Recepisses: 'RECEPISSES',
    Renvoi: 'RENVOI',
    Representant: 'REPRESENTANT',
    ReserveTransporteurFaite: 'RESERVE_TRANSPORTEUR_FAITE',
    SeuilRentabiliteReparationAtteint: 'SEUIL_RETABILITE_REPARATION_ATTEINT',
    SituationArticle: 'SITUATION_ARTICLE',
    SouhaitClient: 'SOUHAIT_CLIENT',
    SuiviColisVerifie: 'SUIVI_COLIS_VERIFIE',
    TempsUsageProduit: 'TEMPS_USAGE_PRODUIT',
    TraitementRetour: 'TRAITEMENT_RETOUR',
    Transporteur: 'TRANSPORTEUR',
    TransporteurCompte: 'TRANSPORTEUR_COMPTE',
    TransporteurInitial: 'TRANSPORTEUR_INITIAL',
    TypeErreurCommande: 'TYPE_ERREUR_COMMANDE',
    TypeQuantite: 'TYPE_QUANTITE',
    TypeRemboursement: 'TYPE_REMBOURSEMENT',
    Rebut: 'REBUT',
    RebutArticlesDeclares: 'REBUT_ARTICLES_DECLARES',
    RepriseMarchandise: 'REPRISE_MARCHANDISE',

    // SAV BY FOUSSIER
    SavByFoussierConcerne: 'SAV_BY_FOUSSIER_CONCERNE',

    // SAV BY FOUSSIER : Produit
    SavByFoussierCategorie: 'SAV_BY_FOUSSIER_CATEGORIE',
    SavByFoussierCodeArticle: 'SAV_BY_FOUSSIER_CODE_ARTICLE',
    SavByFoussierDateFinGarantie: 'SAV_BY_FOUSSIER_DATE_FIN_GARANTIE',

    // SAV BY FOUSSIER : Extension de garantie
    SavByFoussierGarantieEtendue: 'SAV_BY_FOUSSIER_GARANTIE_ETENDUE',
    SavByFoussierDateFinExtensionGarantie: 'SAV_BY_FOUSSIER_DATE_FIN_EXTENSION_GARANTIE',
    SavByFoussierCodeExtensionGarantie: 'SAV_BY_FOUSSIER_CODE_EXTENSION_GARANTIE',

    // SAV BY FOUSSIER : Garantie calculée
    SavByFoussierGarantieCalculee: 'SAV_BY_FOUSSIER_GARANTIE_CALCULEE',
    SavByFoussierDateFinGarantieCalculee: 'SAV_BY_FOUSSIER_DATE_FIN_GARANTIE_CALCULEE',
    
    // SAV BY FOUSSIER : Preuve d'achat
    SavByFoussierPreuveAchat: 'SAV_BY_FOUSSIER_PREUVE_DACHAT',

    // SAV BY FOUSSIER : Prise en charge
    SavByFoussierPriseEnCharge: 'SAV_BY_FOUSSIER_PRISE_EN_CHARGE',
    SavByFoussierForfait: 'SAV_BY_FOUSSIER_FORFAIT',
    SavByFoussierCodeForfaitFoussier: 'SAV_BY_FOUSSIER_CODE_FORFAIT_FOUSSIER',
    SavByFoussierCodeFabricant: 'SAV_BY_FOUSSIER_CODE_FABRICANT',
    SavByFoussierMontantMaximumReparation: 'SAV_BY_FOUSSIER_MONTANT_MAXIMUM_REPARATION',

    // SAV BY FOUSSIER : Bon de transport
    SavByFoussierGestionTransport: 'SAV_BY_FOUSSIER_GESTION_TRANSPORT',
    SavByFoussierRelais: 'SAV_BY_FOUSSIER_RELAIS',
    SavByFoussierClientContactEnlevement: 'SAV_BY_FOUSSIER_CLIENT_CONTACT_ENLEVEMENT',
    SavByFoussierClientInstructionsEnlevement: 'SAV_BY_FOUSSIER_CLIENT_INSTRUCTIONS_ENLEVEMENT',


    RetourMontantEstimeAvoir: 'RETOUR_MONTANT_ESTIME_AVOIR', // Détails de qualification généré à la création
    RetourMontantEstimeAvoirObfusque: 'RETOUR_MONTANT_ESTIME_AVOIR_OBFUSQUE', // Détails de qualification généré à la création (v2, remplace l'affichage du montant estimé)
    RetourMontantTotalLignes: 'RETOUR_MONTANT_TOTAL_LIGNES', // Détails de qualification généré à la création
    RetourDecote: 'RETOUR_DECOTE', // Détails de qualification généré à la création
    RetourMontantFDP: 'RETOUR_MONTANT_FDP', // Détails de qualification généré à la création

};

export const ReclamationQualificationDetailType = {
    ChoixSimple: 0,
    ChoixMultiple: 1,
    Nombre: 2,
    Booleen: 3,
    Texte: 4,
    Liste: 5,
    Date: 6,
    CodeDepot: 7,
    TransporteurId: 8,
    CodeArticleQuantite: 9,
    FournisseurId: 10,
    Flottant: 11,
    MonetaireEuros: 12,
    UtilisateurId: 13,
    CodeArticlesQuantites: 14,
    Fichier: 15,
};

export const ReclamationClotureErrorCodes = {
    MotifResolution: 'motifResolutionId',
    CausePrincipale: 'causePrincipaleId',
    CausePrincipaleDetail: 'causePrincipaleDetailId'
};

export const MotifResolutionCodes = {
    AnnuleClientEmetteur: 'ANNULE_CLIENT_EMETTEUR',
    AvoirClientAvecRetour: 'AVOIR_CLIENT_AVEC_RETOUR',
    AvoirClientSansRetour: 'AVOIR_CLIENT_SANS_RETOUR',
    BLCorrectifsCession: 'BL_CORRECTIFS_CESSION',
    CauseTransporteur: 'CAUSE_TRANSPORTEUR',
    ChangementAdresseLivraison: 'CHANGEMENT_ADRESSE_LIVRAISON',
    ConditionsNonRemplies: 'CONDITIONS_NON_REMPLIES',
    ConditionsNonRempliesPourDeclencherLeRetour: 'CONDITIONS_NON_REMPLIES_POUR_DECLENCHER_LE_RETOUR',
    EnAttentereponse: 'EN_ATTENTE_REPONSE',
    JustifieeClasseeSansSuite: 'JUSTIFIEE_CLASSEE_SANS_SUITE',
    LitigeAttentePaiement: 'LITIGE_ATTENTE_PAIEMENT',
    MauvaiseQualification: 'MAUVAISE_QUALIFICATION',
    NonFondee: 'NON_FONDEE',
    RegularisationFacturationClient: 'REGULARISATION_FACTURATION_CLIENT',
    RenvoiColisChezClient: 'RENVOI_COLIS_CHEZ_CLIENT',
    RenvoiMarchandiseAvoirRenvoi: 'RENVOI_MARCHANDISE_AVOIR_RENVOI',
    RenvoiMarchandiseFacture: 'RENVOI_MARCHANDISE_FACTURE',
    RenvoiMarchandiseNonFacture: 'RENVOI_MARCHANDISE_NON_FACTURE',
    ReparationEffectuee: 'REPARATION_EFFECTUEE',
    RetourClientEffectue: 'RETOUR_CLIENT_EFFECTUE',
    RetourEffectue: 'RETOUR_EFFECTUE',
    RetourTransmisAQualiteEntrepot: 'RETOUR_TRANSMIS_A_QUALITE_ENTREPOT',
};

export const CausePrincipaleCodes = {
    AbimeDansColis: 'ABIME_DANS_COLIS',
    ArbitrageCommerce: 'ARBITRAGE_COMMERCE',
    BLCorrectif: 'BL_CORRECTIF',
    ContestationLivraison: 'CONTESTATION_LIVRAISON',
    DemandeEnlevement: 'DEMANDE_ENLEVEMENT',
    ErreurEmballage: 'ERREUR_EMBALLAGE',
    ErreurExpedition: 'ERREUR_EXPEDITION',
    ErreurPreparation: 'ERREUR_PREPARATION',
    ErreurRangement: 'ERREUR_RANGEMENT',
    ErreurReception: 'ERREUR_RECEPTION',
    ErreurReferencementProduit: 'ERREUR_REFERENCEMENT_PRODUIT',
    ErreurSaisieCommande: 'ERREUR_SAISIE_COMMANDE',
    GesteCommercial: 'GESTE_COMMERCIAL',
    LitigeAttentePaiement: 'LITIGE_ATTENTE_PAIEMENT',
    LitigeCloture: 'LITIGE_CLOTURE',
    LivraisonTransporteurDelai: 'LIVRE_TRANSPORTEUR_DELAI',
    LivraisonTransporteurHorsDelai: 'LIVRE_TRANSPORTEUR_HORS_DELAI',
    ProblemeQualiteFournisseur: 'PROBLEME_QUALITE_FOURNISSEUR',
    ProblemeTransporteur: 'PROBLEME_TRANSPORTEUR',
    RefusFournisseur: 'REFUS_FOURNISSEUR',
    RegularisationFactureClient: 'REGULARISATION_FACTURATION_CLIENT',
    RegularisationStockMagasin: 'REGULARISATION_STOCK_MAGASIN',
    ResoluSansAction: 'RESOLU_SANS_ACTION',
    RetourMarchandises: 'RETOUR_MARCHANDISES',
    Sav: 'SAV',
    SouffranceTransporteur: 'SOUFFRANCE_TRANSPORTEUR'
};

export const GroupeTraitementCodes = {
    ATC: 'ATC',
    Administrateur: 'ADMINISTRATEUR',
    AdministratifsRegion: 'ADMINISTRATIFS_REGION',
    DR: 'DR',
    ForceVente: 'FORCE_VENTE',
    GestionnaireCommercialMagasin: 'GESTIONNAIRE_COMMERCIAL_MAGASIN',
    InterlocuteurSAV: 'INTERLOCUTEUR_SAV',
    Magasin: 'MAGASIN',
    ManagersCommerciaux: 'MANAGERS_COMMERCIAUX',
    MarquesExclusives: 'MARQUES_EXCLUSIVES',
    PiloteRegion: 'PILOTE_REGION',
    QualiteEntrepot: 'QUALITE_ENTREPOT',
    QualiteEntrepotPlateformeVaulx: 'QUALITE_ENTREPOT_PLATEFORME_VAULX',
    QualiteFournisseur: 'QUALITE_FOURNISSEUR',
    SAV: 'SAV',
    ServiceComptabilite: 'SERVICE_COMPTABILITE',
    ServiceRapido: 'SERVICE_RAPIDO',
    ServiceTransport: 'SERVICE_TRANSPORT',
    TraitementRetour: 'TRAITEMENT_RETOUR',
    TraitementRetourPlateformeVaulx: 'TRAITEMENT_RETOUR_PLATEFORME_VAULX',
    ValidationDesDemandesDEnlevement: 'VALIDATION_DEMANDE_ENLEVEMENT',
    RelaisLitige: 'RELAIS_LITIGE',
};

export const TransporteurType = {
    Messager: 0,
    Expressiste: 1
};

export const Modeslivraison = {
    IMM: 'IMM',
    LD: 'LD',
    LF: 'LF',
    MessagerieHorsZone: 'MHZ',
    MZF: 'MZF',
    S: 'S'
};

export const Profils = {
    ADM: 'ADM',
    ADR: 'ADR',
    ATC: 'ATC',
    CA: 'CA',
    CDS: 'CDS',
    CDV: 'CDV',
    CV: 'CV',
    DA: 'DA',
    DC: 'DC',
    DR: 'DR',
    ENT: 'ENT',
    INA: 'INA',
    MAB: 'MAB',
    Magasinier: 'MAG',
    Sedentaire: 'SED',
    SIE: 'SIE',
    SIEGE: 'SIEGE'
};

export const StatutPieceDuJour = {
    NonPieceDuJour: 0,
    DuJourDisponible: 1,
    DuJourIndisponible: 2,
};

export const EligibiliteRetourVolontaire = {
    OK: 0,
    NonCauseRapido: 1,
    NonCauseLivraisonDirecte: 2,
    NonCauseTR: 3,
    NonArticleExclu: 4,
    NonMontantFaible: 5,
    OKSeulementMagasin: 6,
    NonCauseClientFerme: 7,
    NonQuantiteRetournableDepassee: 8,
};

// DEV-4012 : type de pièce source d'une réclamation (cf. Reclamation.Core/Enums/TypePiece.cs).
// null en base = traité comme BonLivraison.
export const TypePiece = {
    BonLivraison: 0,
    DemandeTransfert: 1,
    Commande: 2,
};

export const ExclusionFraisRetourVolontaire = {
    Aucune: 0,
    Client: 1,
    Activite: 2,
    ModeLivraisonProfil: 3,
    Famille: 4,

    MontantMiniClient: 5,
    MontantMiniActivite: 6,
    MontantMiniATC: 7,
};

export const ParametreCodes = {
    PctJokerFraisRetour: 'PCT_JOKER_FRAIS_RETOUR',
    SAVMajorationMontant: 'SAV_MAJORATION_MONTANT',
    SAVMajorationCodeArticle: 'SAV_MAJORATION_CODE_ARTICLE',
    ShuntGenerationAvoir: 'SHUNT_GENERATION_AVOIR',
    ShuntLitigeToDossier: 'SHUNT_LITIGE_TO_DOSSIER',
};



export const GarantieType = {
    SousGarantieNeuf: 0,
    SousGarantieApresUtilisation: 1,
    HorsGarantie: 2
};

export const GarantieTypeNoms = [
    'Sous garantie neuf',
    'Sous garantie après utilisation',
    'Hors garantie',
];

export const PerimetresSAV = {
    Societe: "soc"
};

export const AdresseDestinations = [
    {
        id: 0,
        nom: "Plateforme Monné 1"
    },
    {
        id: 4,
        nom: "Plateforme Vaulx en Velin"
    },
    {
        id: 1,
        nom: "Plateforme Monné 2"
    },
    {
        id: 2,
        nom: "Rapido Monné 2 (Bois, Metal)"
    },
    {
        id: 5,
        nom: "Rapido Le Mans (centre service, finitions, marquage EPI)"
    },
    // L'id ne doit pas changer, reste en dernier cas l'affichage se fera dans l'ordre de définition
    {
        id: 3,
        nom: "Autre adresse"
    },
];


// Codes des dépôts.
export const CodeDepot = {
    PlateformeMonne: '01',
    Rapido: '15',
    PlateformeVaulx: '70'
};

// Dépôts plateforme (Monné / Vaulx) : reprises et départs plateforme.
export const CodesDepotPlateforme = [CodeDepot.PlateformeMonne, CodeDepot.PlateformeVaulx];

// Dépôts non rattachés à un magasin (plateformes + Rapido).
export const CodesDepotHorsMagasin = [CodeDepot.PlateformeMonne, CodeDepot.Rapido, CodeDepot.PlateformeVaulx];

export const KitType = {
    NonDefini: null,
    Compose: 0,
    Composant: 1
};

export const MarcheType = {
    HorsMarche: 0,
    Prive: 1,
    Public: 2
};

export const CompteEtat = {
    EnCompte: 0,   // 'En compte' sur Gescom
    Prospect: 1,   // 'Client'  sur Gescom, on uniformise avec la notion du web / easy
    Ferme: 2       // 'Ferme' ou ni en compte, ni client
};

export const RemboursementType = {
    Cb: 0,
    Especes: 1,
    Virement: 2,
    DeductionFinMois: 3,
    CarteAchat: 4
}

export const RepriseMarchandiseType = {
    Magasin: 0,
    Transfert: 1,
    PlateformeAvoir: 2
}

export const AutorisationRemboursementEnMagasin = {
    NonAutorise: 0,
    Autorise: 1,
    ParComptaUniquement: 2,
    ParComptaUniquementMPU: 3,
    CarteAchat: 4
}

export const ChargerContactExclusionMotif = {
    Aucun: 0,
    Activite: 1,
    Compte: 2
}

export const ArborescenceGestionNiveaux = {
    Groupe: "G",
    SousGroupe: "SG",
    Famille: "F",
    SousFamille: "SF",

}

export const EmailValidationRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const MontantRetourMinimum = 15;
